// Shared by UserList (list row), UserErasurePanel (detail tab) and the modal
// itself. Kept out of the .vue file so the two callers do not have to import
// the whole modal component just to name the event.
export const ERASURE_RECORD_EVENT = "view-erasure-record";
